import { ILayerData } from "@biz/definitions/LayerDefinitions";
import { GroupHelper } from "@biz/logic/GroupHelper";

export function getItemLayerReducers<T extends ILayerData>() {
  return {
    toggleHidden(old: T): T {
      return {
        ...old,
        hidden: !old.hidden
      }
    },
    toggleLocked(old: T): T {
      return {
        ...old,
        locked: GroupHelper.toggleLock(old.locked)
      }
    },
    toggleDecoration(old: T): T {
      return {
        ...old,
        hidden: !old.hidden
      }
    },
  }
}